<!--首页-->
<template>
	<div class="wifiContent">
		<div class="pageModal" v-show="isShowCon">
			<div class="title" v-show="titleOne">
				提示
				<img src="/static/images/forfree/close.png" @click="closeModal" />
			</div>
			<div class="title2" v-show="titleTwo">
				<span>恭喜您领取成功</span>
				<img src="/static/images/wifi/close.png" @click="closeModal" />
			</div>
			<div class="page-cont" v-show="iscontOne">
				<div class="t2">请输入正确的手机号！</div>
			</div>
			<div class="page-cont" v-show="iscontTwo">
				<div class="t2" v-html="cont"></div>
				<div class="tips mtp" v-show="titleTwo">免费试玩账号领取有效期至</div>
				<div class="tips" v-show="titleTwo">{{ endTime }}</div>
				<div class="liqu-button-small" @click="onDownLoad" v-show="downLoad">立即下载</div>
			</div>
		</div>
		<div class="wifi-top">
			<ul class="game-list">
				<li>
					<div class="img tu1">QQ飞车</div>
					<div class="cont">
						<span>随机领取t1-t3账号</span>
						<span>账号价值2500--35500元</span>
					</div>
				</li>

				<li>
					<div class="img tu2">穿越火线</div>
					<div class="cont">
						<span>随机领取10-150V账号</span>
						<span>账号价值8800元--132000元</span>
					</div>
				</li>

				<li>
					<div class="img tu3">绝地求生</div>
					<div class="cont">
						<span>吃鸡号免费玩</span>
						<span>账号价值98元</span>
					</div>
				</li>

				<li>
					<div class="img tu4">逆战</div>
					<div class="cont">
						<span>随机领取创世天神套装号</span>
						<span>账号价值2200--45000元</span>
					</div>
				</li>

				<li>
					<div class="img tu5">英雄联盟</div>
					<div class="cont">
						<span>随机领取50--800皮肤账号</span>
						<span>账号价值4950--87200元</span>
					</div>
				</li>
			</ul>

			<div class="wifi-login">
				<div class="title lqsm">领取免费试玩资格</div>
				<div class="input">
					<input
						type="number"
						placeholder="请输入手机号"
						v-model="moblie"
						oninput="if(value.length>11)value=value.slice(0,11)"
					/>
				</div>
				<div class="code-input">
					<input
						type="number"
						placeholder="请输入验证码"
						v-model="phoneCode"
						oninput="if(value.length>6)value=value.slice(0,6)"
					/>
					<span class="yzmbtn" @click="onClick" v-show="!isSend">获取验证码</span>
					<span class="yzmbtn" v-show="isSend">{{ codeTime }}s</span>
				</div>
				<div class="liqu-button" @click="onButtonClick">立即领取</div>

				<div class="lqsm" style="top: -3px">领取说明</div>
			</div>
		</div>

		<div class="wifi-bottom">
			<div class="wifi-step">
				<!-- <div class="tit"><span class="t1">第一步</span><span class="t2">下载app</span><a class="downbtn" href="http://static.xubei.com/act/download0418/downloadWeb.html?source=wnys">立即下载</a></div>
          <p class="txt"><i>1</i>应用市场下载“虚贝”APP，或复制下方下载链接在浏览器中 打开下载“虚贝APP”；</p>
          <p class="txt"><span>http://static.xubei.com/act/download0418/downloadWeb.html?source=wnys</span><a class="downbtn" data-clipboard-text="http://static.xubei.com/act/download0418/downloadWeb.html?source=wnys">复制</a></p>   -->

				<div class="tit">
					<span class="t1">第一步</span>
					<span class="t2">下载app</span>
					<a class="downbtn" href="http://download.xubei.com/?f=androidApp">立即下载</a>
				</div>
				<p class="txt">
					<i>1</i>
					应用市场下载“虚贝”APP，或复制下方下载链接在浏览器中 打开下载“虚贝APP”；
					<a
						class="downbtn copy_btn"
						href="javascript:"
						:data-clipboard-text="'http://download.xubei.com/?f=androidApp'"
					>
						复制链接
					</a>
				</p>
				<p class="txt"><span>http://download.xubei.com/?f=androidApp</span></p>
			</div>

			<div class="wifi-step">
				<div class="tit">
					<span class="t1">第二步</span>
					<span class="t2">免费兑换账号</span>
				</div>
				<div class="tips">温馨提示：兑换时间为试玩开始时间</div>
				<p class="txt">
					<i>1</i>
					用领取免费试玩资格的手机号登录虚贝App；
				</p>
				<p class="txt">
					<i>2</i>
					点击“我的”-“兑换中心”进入兑换页面；
				</p>
				<p class="txt">
					<i>3</i>
					选择游戏，领取试玩账号
				</p>
			</div>

			<div class="wifi-step">
				<div class="tit">
					<span class="t1">第三步</span>
					<span class="t2">游戏上号</span>
				</div>
				<div class="tips">温馨提示：兑换时间为试玩开始时间</div>
				<p class="txt">
					<i>1</i>
					手游通过账号密码上号；
				</p>
				<p class="txt">
					<i>2</i>
					端游通过虚贝上号器上号，请根据下方链接提前下载上器；
				</p>
				<p class="txt">
					<span>http://act.xubei.com/download/index.html</span>
					<a
						class="downbtn copy_btn"
						href="javascript:"
						:data-clipboard-text="'http://act.xubei.com/download/index.html'"
					>
						复制链接
					</a>
				</p>
				<p class="txt">
					<i>3</i>
					在虚贝App兑换中心的领取记录页面点击“上号说明”查详细上号方式；
				</p>
				<p class="txt copyright">*本活动最终解释权归虚贝所有</p>
			</div>
		</div>

		<div class="pageModal" v-show="isShowModal">
			<div class="tit">
				提示
				<img src="/static/images/wifi/close2.png" />
			</div>
			<div class="cont">
				<p>158****2165已经领取过，直接打开“虚贝”APP登录即可；</p>
				<a href="#" class="download">立即下载</a>
			</div>
		</div>

		<div class="pageModal2" v-show="isShowModal2">
			<div class="tit"><img src="/static/images/wifi/close.png" /></div>
			<div class="pbg">恭喜您领取成功</div>
			<div class="cont">
				<p>158****2165获得了免费试玩资格 下载虚贝APP免费玩</p>
				<div class="tips">免费试玩账号领取有效期至：2018-12-12</div>
				<a href="#" class="download">立即下载</a>
			</div>
		</div>

		<div class="mask" v-show="isMask"></div>
	</div>
</template>

<script>
import { Toast } from 'mint-ui';
import Clipboard from 'clipboard';
import { PROXY_URL } from '../../../config/env';
import { getQueryCode, getPhoneExist } from '../../../service/getData';
let telReg = /^1\d{10}$/;

export default {
	name: 'wifisp',
	components: { Toast },
	components: {},
	data: function () {
		return {
			channel: this.$route.query.channel || '',
			moblie: '',
			cont: '',
			phoneCode: '',
			isChecked: false,
			downLoad: false,
			titleOne: true,
			titleTwo: false,
			isShowCon: false,
			iscontOne: false,
			iscontTwo: false,
			iscontThree: false,
			isShowModal: false,
			isShowModal2: false,
			isMask: false,
			isSend: false,
			codeTime: 60,
			endTime: ''
		};
	},
	mounted() {
		let clipboard = new Clipboard('.copy_btn');
		clipboard.on('success', function (e) {
			Toast('复制成功');
		});
		clipboard.on('error', function (e) {
			Toast('复制失败，请手动复制');
		});
	},
	methods: {
		onClick: function () {
			let self = this;
			if (!telReg.test(self.moblie)) {
				this.isShowCon = true;
				this.iscontOne = true;
				this.isMask = true;
				return false;
			}
			this.ajax
				.get(PROXY_URL.service + '/anon/diversion/vfMobileAndType?mobile=' + self.moblie + '&type=1')
				.then(res => {
					console.log(res);
					if (!res.data.success) {
						self.getZuli();
					} else {
						this.cont =
							this.moblie.substr(0, 3) +
							'****' +
							this.moblie.substr(7) +
							'已经领取过，直接打开“虚贝”APP登录即可,如未安装请先安装APP！';
						this.downLoad = true;
						this.isShowCon = true;
						this.isMask = true;
						this.iscontOne = false;
						this.iscontTwo = true;
					}
				});
			// if(this.isChecked){
			//   this.isShowCon = true
			//   this.iscontOne = false
			//   this.iscontTwo = true
			// }else{
			//   this.isShowCon = true
			//   this.iscontOne = false
			//   this.iscontTwo = false
			//   this.iscontThree = true
			// }
		},
		onButtonClick: function () {
			let self = this;
			if (!telReg.test(self.moblie)) {
				this.isShowCon = true;
				this.isMask = true;
				this.iscontOne = true;
				return false;
			}
			if (this.phoneCode == '') {
				this.cont = '验证码不能为空!';
				this.isShowCon = true;
				this.isMask = true;
				this.iscontOne = false;
				this.iscontTwo = true;
				return false;
			}
			this.ajax
				.get(
					PROXY_URL.service + '/anon/diversion/receive?mobile=' + self.moblie + '&userSource=1&code=' + self.phoneCode
				)
				.then(res => {
					console.log(res);
					if (res.data.success) {
						this.cont =
							this.moblie.substr(0, 3) + '****' + this.moblie.substr(7) + '获得了免费试玩资格,下载虚贝APP免费玩';
						this.titleOne = false;
						this.titleTwo = true;
						this.isShowCon = true;
						this.isMask = true;
						this.iscontOne = false;
						this.iscontTwo = true;
						this.downLoad = true;
						this.endTime = res.data.result.result;
					} else {
						this.cont = res.data.message;
						this.isShowCon = true;
						this.isMask = true;
						this.iscontOne = false;
						this.iscontTwo = true;
					}
				});
		},
		getZuli: function () {
			console.log(this);
			var self = this;
			this.ajax.get(PROXY_URL.user + '/reg/captcha/getUrl').then(res => {
				if (res.data.code == '1') {
					var HEAD = document.getElementsByTagName('head').item(0) || document.documentElement;
					var script = document.createElement('script');
					script.setAttribute('type', 'text/javascript');
					script.setAttribute('src', res.data.result);
					HEAD.appendChild(script);

					script.onload = function () {
						var capOption = { callback: cbfn, type: 'popup' };
						capInit(document.getElementById('TCaptcha'), capOption);
						//回调函数：验证码页面关闭时回调
						self.isMask = true;
						function cbfn(retJson) {
							if (retJson.ret == 0) {
								// 用户验证成功
								console.log(retJson);
								self.isMask = false;

								let data = {
									ticket: retJson.ticket
								};

								self.ajax
									.get(
										PROXY_URL.service +
											'/anon/diversion/sendCode?mobile=' +
											self.moblie +
											'&businessNo=xubei&ticket=' +
											data.ticket
									)
									.then(res => {
										console.log(res);
										if (res.data.code == '1') {
											this.cont = '验证码发送成功!';
											this.isShowCon = true;
											this.isMask = true;
											this.iscontOne = false;
											this.iscontTwo = true;
											self.isSend = true;
											self.countTime();
										} else {
											Toast(res.data.message);
										}
									})
									.catch(error => {});

								capDestroy();
							} else {
								//用户关闭验证码页面，没有验证
								self.isMask = false;
								capDestroy();
							}
						}
					};
				} else {
					self.$toast(res.data.message);
				}
			});
		},
		countTime() {
			let time = 60;
			let self = this;
			let codeT = window.setInterval(function () {
				time--;
				self.codeTime = time;
				if (time == 0) {
					self.isSend = false;
					self.codeTime = 60;
					window.clearInterval(codeT);
				}
			}, 2000);
		},
		onDownLoad: function () {
			window.location.href = 'http://download.xubei.com/?f=androidApp';
		},
		closeModal: function () {
			this.titleOne = true;
			this.titleTwo = false;
			this.isShowCon = false;
			this.iscontOne = false;
			this.iscontTwo = false;
			this.downLoad = false;
			this.isMask = false;
		}
	}
};
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
input::-webkit-input-placeholder {
	/* placeholder颜色  */
	color: #999;
}

.wifiContent {
	width: 100%;
	height: 100%;
	background: #412ce1;
	.lqsm {
		color: #fff;
		text-align: center;
		font-size: px2rem(36rem);
		position: relative;
	}
	.lqsm:after {
		content: '';
		width: px2rem(80rem);
		height: px2rem(9rem);
		background: #8287fc;
		box-shadow: 0 2px 2px 0 #342ec9;
		position: absolute;
		left: 45%;
		bottom: px2rem(-15rem);
	}
	.liqu-button-small {
		background: url(/static/images/forfree/download.png) no-repeat;
		background-size: 100% 100%;
		width: px2rem(264rem);
		height: px2rem(70rem);
		line-height: px2rem(70rem);
		margin: 0 auto;
		font-size: px2rem(32rem);
		color: #ffffff;
		margin-top: px2rem(25rem);
	}
	.wifi-top {
		width: px2rem(750rem);
		height: px2rem(1195rem);
		background: url(/static/images/wifi/bg1.jpg) no-repeat;
		background-size: 100% 100%;

		.game-list {
			overflow: hidden;
			padding-top: px2rem(215rem);
			display: -webkit-box;
			overflow-x: scroll;
			-webkit-overflow-scrolling: touch;
			margin-right: px2rem(20rem);
			margin-bottom: px2rem(15rem);
			li {
				// width: px2rem(360rem);
				width: px2rem(370rem);
				background: #fff;
				border-radius: 8px;
				overflow: hidden;
				margin-left: px2rem(20rem);
				text-align: center;
				.img {
					width: px2rem(265rem);
					height: px2rem(225rem);
					margin: px2rem(15rem) auto;
					padding-top: px2rem(175rem);
					color: #fff;
					font-size: px2rem(32rem);
				}
				.cont {
					background: #ecf2f7;
					padding: px2rem(10rem) 0;
					span {
						display: block;
						font-size: px2rem(24rem);
						color: #19094f;
					}
				}
				.tu1 {
					background: url(/static/images/wifi/tu1.png) no-repeat;
					background-size: cover;
				}
				.tu2 {
					background: url(/static/images/wifi/tu2.png) no-repeat;
					background-size: cover;
				}
				.tu3 {
					background: url(/static/images/wifi/tu3.png) no-repeat;
					background-size: cover;
				}
				.tu4 {
					background: url(/static/images/wifi/tu4.png) no-repeat;
					background-size: cover;
				}

				.tu5 {
					background: url(/static/images/wifi/tu5.png) no-repeat;
					background-size: cover;
				}
			}
		}
		.wifi-login {
			background: url(/static/images/wifi/card.png) no-repeat;
			background-size: cover;
			width: 100%;
			height: px2rem(630rem);
			text-align: center;
			.title {
				font-size: px2rem(36rem);
				color: #ffffff;
				padding-top: px2rem(35rem);
			}
			.input {
				margin-top: px2rem(50rem);
				margin-bottom: px2rem(20rem);
				input {
					width: px2rem(612rem);
					height: px2rem(85rem);
					line-height: px2rem(85rem);
					border-radius: 10px;
					padding-left: px2rem(15rem);
					font-size: px2rem(32rem);
				}
			}
			.code-input {
				input {
					width: px2rem(366rem);
					height: px2rem(86rem);
					line-height: px2rem(86rem);
					border-radius: 10px;
					margin-right: px2rem(34rem);
					padding-left: px2rem(15rem);
					font-size: px2rem(32rem);
				}
				.yzmbtn {
					display: inline-block;
					background: url(/static/images/wifi/getCode.png) no-repeat;
					background-size: cover;
					width: px2rem(214rem);
					height: px2rem(86rem);
					line-height: px2rem(86rem);
					color: #fff;
					font-size: px2rem(32rem);
					vertical-align: middle;
				}
			}
			.liqu-button {
				background: url(/static/images/wifi/linqu.png) no-repeat;
				width: px2rem(445rem);
				height: px2rem(102rem);
				line-height: px2rem(102rem);
				background-size: cover;
				margin: 0 auto;
				font-size: px2rem(36rem);
				color: #ffffff;
				margin-top: px2rem(39rem);
				margin-bottom: px2rem(70rem);
			}
		}
	}
	.wifi-bottom {
		width: px2rem(750rem);
		height: px2rem(1100rem);
		background: url(/static/images/wifi/bg2.jpg) no-repeat;
		background-size: 100% 100%;
		padding: px2rem(30rem) px2rem(50rem);
		.tips-title {
			color: #fff;
			font-size: px2rem(36rem);
			text-align: center;
			margin-bottom: px2rem(50rem);
		}
		.wifi-step {
			margin-bottom: px2rem(32rem);
			.tips {
				font-size: px2rem(24rem);
				color: #ffffff;
				margin-bottom: px2rem(23rem);
			}
			.downbtn {
				display: inline-block;
				background: #be3dff;
				box-shadow: 0 2px 4px 0 #3145c4;
				border-radius: 15px;
				color: #fff;
				width: px2rem(140rem);
				height: px2rem(48rem);
				line-height: px2rem(48rem);
				text-align: center;
			}
			.tit {
				display: flex;
				display: -webkit-flex;
				height: px2rem(52rem);
				line-height: px2rem(52rem);
				margin-bottom: px2rem(20rem);
				.t1 {
					background: url(/static/images/wifi/tips.png) no-repeat;
					width: px2rem(148rem);
					height: px2rem(52rem);
					line-height: px2rem(52rem);
					background-size: cover;
					text-align: center;
					color: #fff;
					font-size: px2rem(28rem);
				}
				.t2 {
					color: #fff;
					font-size: px2rem(28rem);
					padding: 0 px2rem(20rem);
				}
			}
			.txt {
				color: #ebe4ff;
				word-wrap: break-word;
				font-size: px2rem(24rem);
				line-height: px2rem(44rem);
				i {
					color: #ebe4ff;
					border: 1px solid #fff;
					border-radius: 50%;
					display: inline-block;
					width: px2rem(29rem);
					line-height: px2rem(27rem);
					text-align: center;
					font-size: px2rem(22rem);
					margin-right: px2rem(10rem);
				}
				span {
					color: #ebe4ff;
					padding-right: px2rem(20rem);
				}
			}
		}
		.copyright {
			color: #fff;
			opacity: 0.5;
			margin-top: px2rem(30rem);
		}
	}
	.pageModal {
		position: fixed;
		top: 50%;
		left: 50%;
		z-index: 10;
		text-align: center;
		transform: translate(-50%, -50%);
		-webkit-transform: translate(-50%, -50%);
		.tit {
			background: url(/static/images/wifi/titile.png) no-repeat;
			background-size: cover;
			width: px2rem(560rem);
			height: px2rem(76rem);
			line-height: px2rem(76rem);
			color: #fff;
			font-size: px2rem(34rem);
			position: relative;
			img {
				width: px2rem(24rem);
				height: px2rem(24rem);
				position: absolute;
				top: 50%;
				right: px2rem(20rem);
				transform: translate(0, -50%);
				-webkit-transform: translate(0, -50%);
			}
		}
		.cont {
			background: #fff;
			width: px2rem(560rem);
			padding: px2rem(45rem) px2rem(42rem) px2rem(42rem) px2rem(67rem);
			border-bottom-right-radius: 5px;
			border-bottom-left-radius: 5px;
			p {
				font-size: px2rem(30rem);
				color: #333333;
			}
			.download {
				display: block;
				background: url(/static/images/wifi/download.png) no-repeat;
				background-size: cover;
				width: px2rem(264rem);
				height: px2rem(74rem);
				line-height: px2rem(74rem);
				color: #fff;
				margin: px2rem(30rem) auto px2rem(30rem) auto;
			}
		}
	}

	.pageModal2 {
		position: fixed;
		top: 50%;
		left: 50%;
		z-index: 10;
		text-align: center;
		transform: translate(-50%, -50%);
		-webkit-transform: translate(-50%, -50%);
		.tit {
			position: relative;
			height: px2rem(92rem);
			img {
				width: px2rem(56rem);
				height: px2rem(92rem);
				position: absolute;
				top: 50%;
				right: px2rem(20rem);
				transform: translate(0, -50%);
				-webkit-transform: translate(0, -50%);
			}
		}
		.pbg {
			background: url(/static/images/wifi/sc_bg.png) no-repeat;
			width: px2rem(540rem);
			height: px2rem(312rem);
			background-size: cover;
			color: #fff;
			font-size: px2rem(36rem);
			padding-top: px2rem(50rem);
		}
		.cont {
			background: #fff;
			width: px2rem(540rem);
			padding: px2rem(45rem) px2rem(36rem) px2rem(36rem) px2rem(47rem);
			border-bottom-right-radius: 5px;
			border-bottom-left-radius: 5px;
			p {
				font-size: px2rem(30rem);
				color: #333333;
			}
			.tips {
				color: #999;
				font-size: px2rem(24rem);
				margin-top: px2rem(20rem);
			}
			.download {
				display: block;
				background: url(/static/images/wifi/download.png) no-repeat;
				background-size: cover;
				width: px2rem(264rem);
				height: px2rem(74rem);
				line-height: px2rem(74rem);
				color: #fff;
				margin: px2rem(30rem) auto px2rem(30rem) auto;
			}
		}
	}

	.mask {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		background: #000;
		opacity: 0.6;
	}
}
.pageModal {
	width: px2rem(560rem);
	position: absolute;
	left: 50%;
	top: 40%;
	z-index: 10;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	text-align: center;
	.title {
		width: 100%;
		height: px2rem(76rem);
		line-height: px2rem(76rem);
		background: url(/static/images/forfree/title1.png) no-repeat;
		background-size: cover;
		font-size: px2rem(34rem);
		color: #fff;
		position: relative;
		img {
			width: px2rem(24rem);
			height: px2rem(24rem);
			position: absolute;
			right: px2rem(20rem);
			top: 50%;
			-webkit-transform: translate(0, -50%);
			-moz-transform: translate(0, -50%);
			transform: translate(0, -50%);
			padding: px2rem(10rem);
		}
	}
	.title2 {
		width: 100%;
		height: px2rem(312rem);
		background: url(/static/images/wifi/sc_bg.png) no-repeat;
		background-size: cover;
		font-size: px2rem(34rem);
		color: #fff;
		position: relative;
		span {
			color: #fff;
			display: block;
			padding-top: px2rem(50rem);
		}
		img {
			width: px2rem(56rem);
			height: px2rem(92rem);
			position: absolute;
			right: 0;
			top: px2rem(-45rem);
			-webkit-transform: translate(0, -50%);
			-moz-transform: translate(0, -50%);
			transform: translate(0, -50%);
			padding: px2rem(10rem);
		}
	}
	.page-cont {
		background: #fff;
		width: 100%;
		padding: px2rem(35rem) px2rem(32rem) px2rem(48rem) px2rem(32rem);
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
		.t1 {
			color: #333;
			font-size: px2rem(34rem);
			span {
				padding: 0 px2rem(20rem);
				vertical-align: middle;
			}
			img {
				width: px2rem(41rem);
				height: px2rem(41rem);
				vertical-align: middle;
			}
			img:first-child {
				transform: rotate(-90deg);
			}
		}
		.t2 {
			color: #333;
			font-size: px2rem(30rem);
		}

		.tips {
			font-size: px2rem(24rem);
			color: #999;
		}
		.mtp {
			margin-top: px2rem(20rem);
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/wifi/wifisp.vue